import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import { useIsEditing } from 'hooks';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';

import ContentHeading from './ContentHeading';

interface Props extends SitecoreBlockProps {
	fields?: {
		description: Field<string>;
		heading: Field<string>;
	};
}

export default function ContentHeadingBlock({ fields, params }: Props) {
	const isEditing = useIsEditing();
	if (isEditing) {
		return (
			<ComponentPlaceholder
				componentName="ContentHeading"
				deprecated="Deadline Aug 25, 2025 [DP-7854]"
			/>
		);
	}

	if (!fields) {
		return null;
	}

	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
		>
			<ContentHeading
				heading={fields.heading}
				headingLevel={params?.heading}
				description={fields.description}
				className="max-w-col-6"
			/>
		</LayoutContainer>
	);
}
ContentHeadingBlock.displayName = 'ContentHeadingBlock';
